// Mensagem de alerta
(function () {
  'use strict';
  const $msgAlert = $('.alert-bar:not(.top)');
  if ($msgAlert.length > 0) {
    $('body').css('padding-bottom', $msgAlert.height() + 20);
  }
})();

// Resumo fixo (Lateral)
(function () {
  'use strict';
  if (!isMedia('sm') && $('#pagamento-plano').length > 0) {
    const topSpacing = 80;
    const bottomSpacing = 200;
    $('#pagamento-plano').sticky({
      topSpacing: topSpacing,
      bottomSpacing: bottomSpacing,
    });
  }
})();

// Motivo do cancelamento
(function () {
  'use strict';
  const $inputMotivos = $('#form-cancelamento input[name="motivo"]');
  const $inputOutroMotivo = $('#outro_motivo');
  $inputMotivos.on('change', function (ev) {
    ev.preventDefault();
    const $motivo = $(this).first();
    // Motivos padrões
    if ($motivo.attr('id') !== 'cancel-mot6') {
      $inputOutroMotivo.parsley().reset();
      $inputOutroMotivo.prop('required', false);
      $inputOutroMotivo.addClass('d-none');
      $inputOutroMotivo.val('');
    }
    // Outro motivo
    else {
      $inputOutroMotivo.removeClass('d-none');
      $inputOutroMotivo.prop('required', true);
      setTimeout(() => {
        $inputOutroMotivo.focus();
      }, 100);
    }
  });
})();

// Pessoa física / Pessoa jurídica
(function () {
  'use strict';
  if ($('.tipo_pag').length > 0) {
    const $camposFisica = $('.campo-fisica').find('input, select');
    const $camposFisicaReq = $('.campo-fisica').find('input[data-required], select[data-required]');
    const $camposJuridica = $('.campo-juridica').find('input, select');
    const $camposJuridicaReq = $('.campo-juridica').find('input[data-required], select[data-required]');
    $('.tipo_pag').on('change', handleCad);
    function handleCad() {
      const tipo = $('.tipo_pag:checked').val();
      if (tipo === 'f') {
        exibeFisica();
      } else if (tipo === 'j') {
        exibeJuridica();
      }
    }
    if ($('[data-checkout="docNumber"]').length) {
      $('#cpf, #cnpj').on('change', function () {
        if ($(this).val()) {
          $('[data-checkout="docNumber"]').val(somenteNumeros($(this).val()));
        }
      });
    }

    handleCad();
    function exibeFisica() {
      $('.campo-juridica').hide();
      $camposJuridica.each(function () {
        const $input = $(this);
        $input.val('');
        $input.prop('required', false);
        $input.prop('disabled', true);
        $input.parsley().reset();
      });
      $('.campo-fisica').show();
      $camposFisica.each(function () {
        const $input = $(this);
        $input.prop('disabled', false);
        $input.parsley().reset();
      });
      $camposFisicaReq.each(function () {
        const $input = $(this);
        $input.prop('required', true);
      });
      if ($('#docType').length) {
        $('#docType').val('CPF');
      }
    }
    function exibeJuridica() {
      $('.campo-fisica').hide();
      $camposFisica.each(function () {
        const $input = $(this);
        $input.val('');
        $input.prop('required', false);
        $input.prop('disabled', true);
        $input.parsley().reset();
      });
      $('.campo-juridica').show();
      $camposJuridica.each(function () {
        const $input = $(this);
        $input.prop('disabled', false);
        $input.parsley().reset();
      });
      $camposJuridicaReq.each(function () {
        const $input = $(this);
        $input.prop('required', true);
      });
      if ($('#docType').length) {
        $('#docType').val('CNPJ');
      }
    }
  }
})();

// Gera token do cartão
(function () {
  'use strict';

  const regenerateSeconds = 30;
  const generateLimit = 50;

  $('#form-pagamento, #form-update-card, #form-cobranca').each(function () {
    if ($(this).find('[name="payment_method"]').val() !== 'pix') {
      initCardTokenGenerator($(this));
    }
  });

  function initCardTokenGenerator($form) {
    const $cardInputs = $form.find('.card-dados');
    const $cardHashInput = $form.find('input[name="card_hash"]');
    const $cardHashTime = $form.find('input[name="card_hash_time"]');
    const $btnSubmit = $form.find('button[type="submit"]');
    const publicKey = $form.find('[name="encription_key"]').val();

    let loading = false;
    let cardHash = null;
    let lastCardData = null;
    let lastHashTimestamp = 0;
    let generateCount = 0;

    $cardInputs.on('input change keyup', debounce(getCardHash, 100, true));

    setInterval(() => {
      if (shouldGenerateNewHash()) {
        getCardHash();
      }
    }, 5000);

    function getCardHash() {
      if (loading) return;

      let cardNumber = somenteNumeros($form.find('[name="card_number"]').val());
      let cardName = $form.find('[name="card_name"]').val();
      let cardExpMonth = parseInt($form.find('[name="card_valid_month"]').val());
      let cardExpYear = parseInt($form.find('[name="card_valid_year"]').val());
      let cardCVV = $form.find('[name="card_cvc"]').val();

      const isFormValid =
        cardNumber &&
        cardNumber.length >= 15 &&
        cardName &&
        cardExpMonth &&
        cardExpYear &&
        cardCVV &&
        cardCVV.length >= 3;

      if (!isFormValid) return;

      if (!luhnValidate(cardNumber)) {
        console.warn('Número do cartão inválido');
        return;
      }

      const currentCardData = {
        number: cardNumber,
        holder_name: cardName,
        exp_month: cardExpMonth,
        exp_year: cardExpYear,
        cvv: cardCVV,
      };

      if (cardHash && lastCardData && compareCardData(currentCardData, lastCardData) && !isTimeToRegenerate()) {
        return;
      }

      disableBtn();
      loading = true;
      generateCount++;
      if (generateCount > generateLimit) {
        location.reload();
      }

      $.ajax({
        url: 'https://api.pagar.me/core/v5/tokens?appId=' + publicKey,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ type: 'card', card: currentCardData }),
        success: function (resp) {
          loading = false;
          enableBtn();
          if (resp?.id) {
            cardHash = resp;
            lastCardData = currentCardData;
            lastHashTimestamp = Date.now();
            $cardHashInput.val(resp.id);
            $cardHashTime.val(lastHashTimestamp.toString());
            console.log('Novo hash gerado:', resp.id);
          } else {
            reset();
            console.warn('Falha ao gerar hash:', resp);
          }
        },
        error: function () {
          loading = false;
          enableBtn();
          reset();
          console.error('Erro ao gerar hash');
        },
      });
    }

    function shouldGenerateNewHash() {
      if (!cardHash || !lastCardData) return true;
      if (isTimeToRegenerate()) return true;

      const currentCardData = {
        number: somenteNumeros($form.find('[name="card_number"]').val()),
        holder_name: $form.find('[name="card_name"]').val(),
        exp_month: parseInt($form.find('[name="card_valid_month"]').val()),
        exp_year: parseInt($form.find('[name="card_valid_year"]').val()),
        cvv: $form.find('[name="card_cvc"]').val(),
      };

      return !compareCardData(currentCardData, lastCardData);
    }

    function isTimeToRegenerate() {
      const now = Date.now();
      return (now - lastHashTimestamp) / 1000 >= regenerateSeconds;
    }

    function compareCardData(current, previous) {
      return (
        current.number === previous.number &&
        current.holder_name === previous.holder_name &&
        current.exp_month === previous.exp_month &&
        current.exp_year === previous.exp_year &&
        current.cvv === previous.cvv
      );
    }

    function disableBtn() {
      $btnSubmit.prop('disabled', true);
    }

    function enableBtn() {
      $btnSubmit.prop('disabled', false);
    }

    function reset() {
      cardHash = null;
      lastCardData = null;
      lastHashTimestamp = 0;
    }
  }

  // Debounce utilitário
  function debounce(func, wait, immediate) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Exemplo de função para limpar caracteres não numéricos
  function somenteNumeros(valor) {
    return valor.replace(/\D/g, '');
  }

  // Exemplo simples de validação Luhn (se já tiver no seu código, use o seu)
  function luhnValidate(num) {
    let arr = (num + '')
      .split('')
      .reverse()
      .map((x) => parseInt(x));
    let sum = arr.reduce((acc, val, i) => {
      if (i % 2) {
        val *= 2;
        if (val > 9) val -= 9;
      }
      return acc + val;
    }, 0);
    return sum % 10 === 0;
  }
})();

// Utilizar cartão cadastrado ou cadastrar um novo
(function () {
  'use strict';
  if ($('input[name="novo_cartao"]').length > 0) {
    // Exibe o alerta caso o e-mail for alterado (Pagar.me V5)
    const $inputEmail = $('#form-pagamento #email');
    if ($inputEmail.data('original')) {
      $inputEmail.on('change', function () {
        if ($inputEmail.val() && $inputEmail.val() !== $inputEmail.data('original') && $('.card-select').length > 0) {
          $('input[name="novo_cartao"][value="0"]').prop('checked', false).prop('disabled', true);
          $('input[name="novo_cartao"][value="1"]').prop('checked', true).trigger('change');
          Alert.fire({
            type: 'warning',
            title: 'Atenção!',
            html: 'Em caso de <b>alteração do e-mail</b>, será necessário <b>cadastrar novamente o cartão de crédito</b> ou, se preferir, <b>adicione um novo cartão</b> para continuar com a contratação do novo plano.',
            cancelButtonText: 'Fechar',
          });
        } else {
          $('input[name="novo_cartao"][value="0"]').prop('disabled', false).prop('checked', true).trigger('change');
        }
      });
    }

    $('input[name="novo_cartao"]').on('change', handleCamposCartao);
    handleCamposCartao();
    function handleCamposCartao() {
      const opcao = $('input[name="novo_cartao"]:checked').val();
      const $camposCartao = $('.campos-cartao');
      const $camposCartaoInputs = $camposCartao.find('input, select, textarea');
      if (opcao == '1') {
        $camposCartao.slideDown();
        $camposCartaoInputs.prop('required', true);
      } else {
        $camposCartao.slideUp();
        $camposCartaoInputs.prop('required', false);
      }
      $camposCartaoInputs.each(function () {
        $(this).parsley().reset();
      });
    }
  }
})();

// Cartão
(function () {
  'use strict';
  const $cardWrappers = $('.card-wrapper[data-form]');
  if ($cardWrappers.length > 0) {
    $cardWrappers.each(function () {
      const $el = $(this);
      const form = $el.data('form');
      const card = new Card({
        form: form,
        container: '.card-wrapper',
        formSelectors: {
          numberInput: 'input#card_number',
          expiryInput: 'input#expiry',
          cvcInput: 'input#card_cvc',
          nameInput: 'input#card_name',
        },
        placeholders: {
          number: '•••• •••• •••• ••••',
          name: 'NOME COMPLETO',
          expiry: 'MM/AA',
          cvc: '•••',
        },
      });
      if ($('#card_number').val()) {
        updateCardRender();
      }
    });

    // Forçaa renderezação do cartão ao editar
    function updateCardRender() {
      setTimeout(() => {
        const changeEvent = new CustomEvent('change');
        const blurEvent = new CustomEvent('blur');
        document.getElementById('card_number').dispatchEvent(changeEvent);
        document.getElementById('card_number').dispatchEvent(blurEvent);
        $('#card_number').parsley().reset();
        document.getElementById('card_name').dispatchEvent(changeEvent);
        document.getElementById('card_name').dispatchEvent(blurEvent);
        $('#card_name').parsley().reset();
        document.getElementById('card_cvc').dispatchEvent(changeEvent);
        document.getElementById('card_cvc').dispatchEvent(blurEvent);
        $('#card_cvc').parsley().reset();
        document.getElementById('card_valid_year').dispatchEvent(changeEvent);
        document.getElementById('card_valid_year').dispatchEvent(blurEvent);
        $('#card_valid_year').parsley().reset();
        document.getElementById('card_valid_month').dispatchEvent(changeEvent);
        document.getElementById('card_valid_month').dispatchEvent(blurEvent);
        $('#card_valid_month').parsley().reset();
      }, 100);
    }

    // Atualiza a data de validade do cartão
    const yearInput = '#card_valid_year';
    const monthInput = '#card_valid_month';
    $(monthInput).change(updateCardExpiry);
    $(yearInput).change(updateCardExpiry);
    function updateCardExpiry() {
      const year = $(yearInput).val() == '' ? 'AA' : $(yearInput).val().slice(-2);
      const month = $(monthInput).val() == '' ? 'MM' : $(monthInput).val();
      $('.jp-card-expiry').text(month + '/' + year);
    }
  }
})();

// Detalhe da cobrança
(function () {
  'use strict';

  // Variáveis
  const urlApi = $('#api-subscription').data('url');
  const urlOrder = $('#api-subscription').data('order');
  const $modal = $('#modal-det-cobranca');
  const $modalOrders = $('#modal-det-pedidos-cobranca');
  const $ordersList = $modalOrders.find('tbody');
  const $btnViewDet = $('.btn-det-cobranca');
  const $btnViewOrders = $('.btn-det-cobranca-pedidos');
  const $formPayment = $('#form-cobranca');
  const $btnPayment = $formPayment.find('.btn-submit');
  const $paymentMethod = $formPayment.find('input[name="payment_method"]');
  const $paymentBox = $('.cobranca-pagamento');
  const $paymentPix = $('.cobranca-pix');
  const $paymentOrder = $('.cobranca-pedido');
  const curDate = new Date().toISOString().slice(0, 10);
  const paymentMethods = {
    credit_card: 'Cartão de crédito',
    boleto: 'Boleto bancário',
    pix: 'Pix',
  };
  let verifyPixTimer = null;

  // Ao clicar no botão para visualizar os detalhes da cobrança
  $btnViewDet.on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const cobrancaId = $btn.data('registro');
    getCharge(cobrancaId);
  });

  // Seleção do método de pagamento
  $paymentMethod.on('change', function () {
    const paymentMethod = $('#form-cobranca input[name="payment_method"]:checked').val();
    if (paymentMethod === 'credit_card') {
      $('.cp-credit-card-content .form-control').each(function () {
        $(this).val('').prop('disabled', false).prop('required', true).parsley().reset();
      });
      $('.cp-pix-content').slideUp(function () {
        $('.cp-credit-card-content').slideDown();
        //$btnPayment.prop('disabled', true);
      });
    }
    if (paymentMethod === 'pix') {
      $('.cp-credit-card-content .form-control').each(function () {
        $(this).val('').prop('disabled', true).prop('required', false).parsley().reset();
      });
      $('.cp-credit-card-content').slideUp(function () {
        $('.cp-pix-content').slideDown();
        $btnPayment.prop('disabled', false);
      });
    }
  });

  // Exibe o modal com os pedidos da cobrança
  $btnViewOrders.on('click', function (ev) {
    $modal.modal('hide');
    $modalOrders.modal('show');
  });
  $modalOrders.on('hidden.bs.modal', function () {
    $modal.modal('show');
  });

  // Carrega os detalhes da cobrança
  function getCharge(chargeId) {
    showLoader();
    $.getJSON(`${urlApi}?charge=${chargeId}`, function (resp) {
      console.log(resp);
      hideLoader();
      if (verifyPixTimer !== null) {
        clearInterval(verifyPixTimer);
        verifyPixTimer = null;
      }
      if (resp.status === 'success') {
        const charge = resp.result;
        // Fecha o modal de alertas, se estiver aberto
        if ($('#modal-alert-cobrancas').hasClass('show')) {
          $('#modal-alert-cobrancas').modal('hide');
        }
        // Exibe as informações
        populateCharge(charge);
        $modal.modal('show');
      } else {
        Toast.fire({
          type: 'error',
          title: resp.message,
        });
      }
    }).fail(function (resp) {
      console.log(resp);
      hideLoader();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível carregar a cobrança.',
      });
    });
  }

  // Exibe as informações da cobrança
  function populateCharge(charge) {
    $modal.find('input[name="charge_id"]').val(charge.id);
    $('#dc_periodo').val(`${formataDataExt(charge.period_start)} a ${formataDataExt(charge.period_end)}`);
    $('#dc_percentage').val(formatMoneyBR(charge.percentage));
    $('#dc_total_amount').val(formatMoneyBR(charge.total_amount));
    $('#dc_amount').val(formatMoneyBR(charge.amount));
    $('#dc_status').html(
      `<span class="badge badge-pill badge-${charge.status_color}" style="padding: .65em 1.2em; font-size: 0.85em;">${charge.status_text}</span>`,
    );
    populateChargeOrders(charge.orders);
    // Exibe detalhes do pagamento (Cobrança paga)
    if (charge.status === 'paid' || charge.status === 'captured' || charge.status === 'refunded') {
      populateChargeOrder(charge);
    }
    // Exibe informações para pagamento via Pix (Cobrança pendente mas com pix gerado)
    else if (charge.payment_method === 'pix' && charge.pix_qr_code && charge.pix_expiration >= curDate) {
      showPixPayment(charge);
    }
    // Exibe formulário para pagamento
    else {
      $paymentOrder.hide();
      $paymentPix.hide();
      $('#cp-pix').prop('checked', true).trigger('change');
      $paymentBox.show();
    }
  }

  // Carrega os pedidos da cobrança
  function populateChargeOrders(orders) {
    $ordersList.html('');
    if (orders && orders.length) {
      orders.forEach((ocI) => {
        $ordersList.append(`<tr>
        <td data-label="Pedido:"><a class="link" href="${urlOrder + ocI.order_id}" target="_blank">#${
          ocI.token
        }</a></td>
        <td data-label="Total:">R$ ${formatMoneyBR(ocI.amount)}</td>
      </tr>`);
      });
    }
  }

  // Exibe as informações do pagamento da cobrança, quando for paga
  function populateChargeOrder(charge) {
    $paymentBox.hide();
    $paymentPix.hide();
    $('.v-payment-method').text(paymentMethods[charge.payment_method]);
    if (charge.status === 'paid' || charge.status === 'captured') {
      $('.l-payment-date').text('Data do pagamento:');
    } else {
      $('.l-payment-date').text('Atualizado em:');
    }
    $('.v-payment-date').text(formataDataExt(charge.updated_at, '{d}/{m}/{Y} às {H}h{i}'));
    $paymentOrder.show();
  }

  // Exibe informações para pagamento via Pix
  function showPixPayment(charge) {
    $paymentBox.hide();
    $paymentOrder.hide();
    $('#cob-cod-pix').val(charge.pix_qr_code);
    renderQrCode(charge.pix_qr_code);
    verifyPayment(charge.id);
    $paymentPix.show();
  }

  // Retorno do formulário de pagamento
  $modal.on('charge-form-success', function (evt, data) {
    paymentSuccess(data);
  });
  function paymentSuccess(resp) {
    console.log(resp);
    const charge = resp.charge;
    if (!charge.id) {
      Toast.fire({
        type: 'error',
        title: 'Não foi possível identificar a transação.',
      });
      return false;
    }
    // Pagamento via Pix
    if (charge.payment_method === 'pix' && charge.pix_qr_code && charge.pix_expiration >= curDate) {
      populateCharge(charge);
    }
    // Cartão de crédito
    else if (charge.payment_method === 'credit_card' && (charge.status === 'paid' || charge.status === 'captured')) {
      populateCharge(charge);
      Alert.fire({
        type: 'success',
        title: 'Pagamento Realizado!',
        html: 'O pagamento foi confirmado com sucesso.',
        cancelButtonText: 'Ok',
      });
    } else {
      Alert.fire({
        type: 'error',
        title: 'Erro',
        html: resp.mensagem,
        cancelButtonText: 'Fechar',
      });
    }
  }

  // Renderiza o QR Code para pagamento via Pix
  function renderQrCode(qrCode) {
    $('.qrcode-cob').html('');
    if ($('.qrcode-cob').length > 0) {
      const $qrCode = $('.qrcode-cob');
      if (qrCode) {
        const qrCodeGenerator = new QRCode($qrCode[0], {
          text: qrCode,
          width: 300,
          height: 300,
        });
        $qrCode.addClass('generated');
      }
    }
  }

  // Consulta o status do pagamento (Pix)
  function verifyPayment(chargeId) {
    const limitAttempts = 100;
    let attempts = 0;
    let loading = false;
    if (verifyPixTimer !== null) {
      clearInterval(verifyPixTimer);
      verifyPixTimer = null;
    }
    verifyPixTimer = setInterval(function () {
      if (loading) {
        return;
      }
      attempts++;
      if (attempts < limitAttempts) {
        loading = true;
        $.getJSON(`${urlApi}?charge=${chargeId}`, function (resp) {
          loading = false;
          if (resp.status === 'success') {
            const charge = resp.result;
            console.log('Status: ' + charge.status);
            if (charge.status === 'paid' || charge.status === 'captured') {
              clearInterval(verifyPixTimer);
              verifyPixTimer = null;
              populateCharge(charge);
              Alert.fire({
                type: 'success',
                title: 'Pagamento Realizado!',
                html: 'O pagamento foi recebido e confirmado com sucesso.',
                cancelButtonText: 'Ok',
              });
            }
          }
        }).fail(function (resp) {
          console.log(resp);
          loading = false;
          clearInterval(verifyPixTimer);
          verifyPixTimer = null;
        });
      } else {
        console.log('Limite de tentativas atingido: ' + limitAttempts);
        clearInterval(verifyPixTimer);
        verifyPixTimer = null;
      }
    }, 3000);
  }
})();

// Retorno da criação da transação
function chargePaymentSuccess(resp) {
  $('#modal-det-cobranca').trigger('charge-form-success', resp);
}

// Exibe o pagamento da mensalidade via Pix
(function () {
  'use strict';
  const $modalPayment = $('#modal-pay-invoice');
  let verifyPixTimer = null;

  // Ao exibir o modal da cobrança
  $modalPayment.on('show.bs.modal', function () {
    const qrcode = $('.qrcode-inv').data('qrcode');
    const invoiceId = $modalPayment.data('invoice');
    if (invoiceId && qrcode) {
      renderQrCode(qrcode);
      setTimeout(() => {
        verifyPayment(invoiceId);
      }, 10000);
    }
  });

  // Renderiza o QR Code para pagamento via Pix
  function renderQrCode(qrCode) {
    $('.qrcode-inv').html('');
    if ($('.qrcode-inv').length > 0) {
      const $qrCode = $('.qrcode-inv');
      if (qrCode) {
        const qrCodeGenerator = new QRCode($qrCode[0], {
          text: qrCode,
          width: 300,
          height: 300,
        });
        $qrCode.addClass('generated');
      }
    }
  }

  // Consulta o status do pagamento (Pix)
  function verifyPayment(invoiceId) {
    const urlApi = $('#api-subscription').data('url');
    const limitAttempts = 100;
    let attempts = 0;
    let loading = false;
    if (verifyPixTimer !== null) {
      clearInterval(verifyPixTimer);
      verifyPixTimer = null;
    }
    verifyPixTimer = setInterval(function () {
      if (loading) {
        return;
      }
      attempts++;
      if (attempts < limitAttempts) {
        loading = true;
        $.getJSON(`${urlApi}?invoice=${invoiceId}`, function (resp) {
          loading = false;
          if (resp.status === 'success') {
            const invoice = resp.result;
            console.log('Status: ' + invoice.status);
            if (invoice.status === 'paid' || invoice.status === 'captured') {
              clearInterval(verifyPixTimer);
              verifyPixTimer = null;
              $('#modal-pay-invoice').modal('hide');
              Alert.fire({
                type: 'success',
                title: 'Pagamento Realizado!',
                html: 'O pagamento foi recebido e confirmado com sucesso.',
                cancelButtonText: 'Ok',
              });
              setTimeout(() => {
                location.reload();
              }, 5000);
            }
          }
        }).fail(function (resp) {
          console.log(resp);
          loading = false;
          clearInterval(verifyPixTimer);
          verifyPixTimer = null;
        });
      } else {
        console.log('Limite de tentativas atingido: ' + limitAttempts);
        clearInterval(verifyPixTimer);
        verifyPixTimer = null;
      }
    }, 3000);
  }
})();
